// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"5f642280","796":"2f83d255"}[chunkId] + ".chunk.js";
};